import { initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { VITE_FIREBASE_API_KEY, VITE_FIREBASE_AUTH_DOMAIN } from "./env";

let auth: Auth | undefined;

export function getFirebaseAuth() {
  auth ??= getAuth(
    initializeApp({
      apiKey: VITE_FIREBASE_API_KEY,
      authDomain: VITE_FIREBASE_AUTH_DOMAIN,
    })
  );
  return auth;
}
